/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { Psp } from "./Psp";
import * as t from "io-ts";

// required attributes
const PspListResponseCDR = t.interface({});

// optional attributes
const PspListResponseCDO = t.partial({
  data: t.readonlyArray(Psp, "array of Psp")
});

export const PspListResponseCD = t.intersection(
  [PspListResponseCDR, PspListResponseCDO],
  "PspListResponseCD"
);

export type PspListResponseCD = t.TypeOf<typeof PspListResponseCD>;
